import React, { useState } from 'react';
import { Box, Button, CircularProgress, TextField, Typography, Alert } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { motion } from 'framer-motion';
import QuoteCard from './QuoteCard';

const AiQuotePanel = ({ apiBaseUrl, onToggleFavorite, isQuoteFavorite }) => {
  const [prompt, setPrompt] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  const handleGenerate = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${apiBaseUrl}/api/ai/quote`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ prompt })
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `Erreur réseau: ${response.status}`);
      }

      const data = await response.json();
      setResult(data);
    } catch (fetchError) {
      setError(`Impossible de générer la citation IA: ${fetchError.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography variant="h6" align="center" sx={{ mb: 2 }}>
        Génère une citation personnalisée avec l'IA
      </Typography>

      <TextField
        fullWidth
        label="Thème (optionnel)"
        placeholder="Ex: résilience, dépassement de soi, esprit d'équipe..."
        value={prompt}
        onChange={(event) => setPrompt(event.target.value)}
        inputProps={{ maxLength: 160 }}
        sx={{ mb: 2 }}
      />

      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
        <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleGenerate}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={18} color="inherit" /> : <AutoAwesomeIcon />}
            sx={{
              borderRadius: '50px',
              px: 4,
              py: 1.2,
              textTransform: 'none',
              fontSize: '1rem'
            }}
          >
            {loading ? 'Génération...' : 'Générer avec IA'}
          </Button>
        </motion.div>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {result?.source === 'fallback' && (
        <Alert severity="info" sx={{ mb: 2 }}>
          {result.warning || "Le service IA est momentanément indisponible, une citation locale est affichée."}
        </Alert>
      )}

      {result?.quote && (
        <QuoteCard
          quote={result}
          onToggleFavorite={onToggleFavorite}
          isFavorite={isQuoteFavorite(result.quote)}
        />
      )}
    </Box>
  );
};

export default AiQuotePanel;
